import { render, staticRenderFns } from "./CSInputPetunjuk.vue?vue&type=template&id=5ab08793&"
import script from "./CSInputPetunjuk.vue?vue&type=script&lang=js&"
export * from "./CSInputPetunjuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports